import React from 'react';
import { Badge } from './ui/badge';
import ColumnSelector from './ColumnSelector';

// Product table header with controls and column display
const ProductTableHeader = ({
  title,
  currentColumns,
  fieldLabels,
  onColumnToggle,
  onOpenFullManager,
  onReset
}) => {
  return (
    <>
      {/* Header with column controls */}
      <div className="flex justify-between items-center mb-4">
        <h6 className="text-lg font-semibold">{title}</h6>
        <div className="flex gap-2">
          <ColumnSelector
            currentColumns={currentColumns}
            onColumnToggle={onColumnToggle}
            onOpenFullManager={onOpenFullManager}
            onReset={onReset}
          />
        </div>
      </div>

      {/* Current columns display */}
      <div className="mb-4">
        <p className="text-sm text-muted-foreground mb-2">
          当前显示的列 ({currentColumns.length}):
        </p>
        <div className="flex flex-wrap gap-1">
          {currentColumns.map((columnId, index) => (
            <Badge
              key={columnId}
              variant="outline"
              className="text-xs"
            >
              {index + 1}. {fieldLabels[columnId] || columnId}
            </Badge>
          ))}
        </div>
      </div>
    </>
  );
};

export default ProductTableHeader;
